import { render } from "./MellonWebECRTransactionsModal.vue?vue&type=template&id=6875fea3"
import script from "./MellonWebECRTransactionsModal.vue?vue&type=script&lang=js"
export * from "./MellonWebECRTransactionsModal.vue?vue&type=script&lang=js"

import "./MellonWebECRTransactionsModal.vue?vue&type=style&index=0&id=6875fea3&lang=less"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__